import { render, staticRenderFns } from "./TabBank.vue?vue&type=template&id=ffd8ada8&"
import script from "./TabBank.vue?vue&type=script&lang=js&"
export * from "./TabBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports